import { styled } from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

import { integrationMaxWidth } from "app/pages/sales-intelligence/pages/manage-export/style";

export const StyledPlaybooksPageContainer = styled(Stack)`
    ${integrationMaxWidth};
`;
